var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('back-to-home'),(_vm.memberId)?_c('submit-form',{attrs:{"is-edit":true,"member-id":_vm.memberId},on:{"submit":_vm.onSubmit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }